import isListingOnSale from "./isListingOnSale";

export const currentProductPrice = async (product) => {
  let offerPrice = null;

  if (isListingOnSale(product)) {
    if (product?.listing_sale_price) {
      offerPrice = product?.listing_sale_price;
    } else {
      offerPrice = product?.listing_price - (product?.listing_price * product?.listing_sale_percent) / 100;
    }
  }

  const isSooperDeal =
    product?.sooperdeal_price &&
    product?.sooperdeal_stock_amount !== 0 &&
    product?.sooperdeal_start_date &&
    product?.sooperdeal_expiration_date &&
    new Date(product.sooperdeal_start_date) <= new Date() &&
    new Date(product.sooperdeal_expiration_date) >= new Date();

  let sooperdealPrice = null;
  if (isSooperDeal) {
    sooperdealPrice = product?.sooperdeal_price;
  }

  const finalPrice = sooperdealPrice || offerPrice || product?.listing_price || 0;
  const priceType = sooperdealPrice ? "sooperdeal_price" : offerPrice ? "offer_price" : "listing_price";

  if (finalPrice === 0) {
    return {
      finalPrice: 0,
      priceType: "listing_price",
      listing_price: 0,
    };
  } else {
    return {
      finalPrice: finalPrice ? parseFloat(finalPrice).toFixed(2) : 0,
      priceType: priceType,
      listing_price: product?.listing_price ? product?.listing_price.toFixed(2) : 0,
    };
  }
};
